import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
// mui components
import {
  Paper,
  Divider,
  styled,
  Grid,
  Box,
  Button,
  Modal,
  Typography,
  Stack
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from "@mui/icons-material/Business";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import { Link } from "react-router-dom";
import FormHelperText from "@mui/material/FormHelperText";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import LinearProgress from "@mui/material/LinearProgress";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import RateDrawer from "../../pages/General/RateDrawer";
import Notification from "../../pages/General/Notification";
import TrackingDrawer from "../../pages/General/TrackingDrawer";
import {
  doGetRate,
  resetRateState,
} from "../../pages/Shipments/NewShipment/rateSlice";
import { resetGenerateLabel } from "../../pages/Shipments/NewShipment/createShipmentSlice";
import { fetchCustomerDetails } from "../../pages/Reports/Deliveries/trackingEventsSlice";
import {
  fetchOnboardingData,
  useraccountactivate,
  stripeuseraccountVerification,
  resetOnboarding,
} from "./onboardingSlice";
import { fetchLabelData, departureScan, resetLabelData, resetLabel } from "./dashboardSlice";
import { resetOrderNotifications } from "../../pages/Orders/ordersSlice";
import NewOrderCreateDrawer from "../General/NewOrder/NewOrderCreateDrawer";
import BulkOrderCreateDrawer from "../../pages/General/BulkOrderCreateDrawer";
import Printer from "../../pages/General/Printer";
import BusinessVerification from "../../pages/General/BusinessVerification";
import VerifyButton from "../../pages/General/VerifyButton";
import {
  fetchCountry,
  fetchState,
} from "../../pages/General/countryStateCitySlice";
import { storeQuestionerData, resetNotification } from "../../pages/Auth/authSlice";
import { fetchProfile } from '../Settings/Profile/profileSlice';
import { fetchBoxData } from '../../pages/Settings/Box/boxSlice';

import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import LoadingButton from "@mui/lab/LoadingButton";
import Chip from "@mui/material/Chip";
import Slider from "@mui/material/Slider";
import MuiInput from "@mui/material/Input";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from '@mui/material/IconButton';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import FormGroup from "@mui/material/FormGroup";
import Slide from "@mui/material/Slide";
import ClearIcon from "@mui/icons-material/Clear";
import { set } from "date-fns";
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { loadStripe } from '@stripe/stripe-js';
import { CropLandscapeOutlined } from "@material-ui/icons";

const Input = styled(MuiInput)`
  width: 42px;
`;
const CustomButton = styled(Button)({
  backgroundColor: "#1976d2", // Dark background
  color: "#FFFFFF", // White text
  padding: "12px 16px",
  borderRadius: "8px",
  textTransform: "none",
  justifyContent: "flex-start",
  gap: "8px",
  fontSize: "14px !important",
  fontWeight: "700",
  minWidth: "280px", // Set a minimum width to match button size
  "&:hover": {
    backgroundColor: "#1976d2",
  },
});
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  outline: "none",
  p: 4,
};

const modalStyleLabel = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  outline: "none",
  p: 4,
};

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  boxShadow: "unset",
  border: "1px solid rgba(0, 0, 0, 0.12)",
  color: theme.palette.text.secondary,
  height: "100%",
  scrollbarColor: "red green",
  "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
    backgroundColor: "rgb(187 182 182 / 87%)",
    width: "5px",
  },
  "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
    borderRadius: 8,
    backgroundColor: "#1976d2",
    minHeight: 24,
    border: "1px solid #1976d2",
  },
  "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus": {
    backgroundColor: "#1976d2",
  },
  "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active": {
    backgroundColor: "#1976d2",
  },
  "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "#1976d2",
  },
  "&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner": {
    backgroundColor: "#1976d2",
  },
}));

const Iconstyle = {
  height: "40px",
  width: "40px",
  marginRight: "15px",
  color: "#1976d2",
};

const DashboardPage = ({ }) => {
  const [countryVolume, setCountryVolume] = React.useState({
    canada: 80,
    us: 50,
    international: 30,
  });
  const [otherStoreVisible, setOtherStoreVisible] = React.useState(false);
  const [otherStoreValue, setOtherStoreValue] = React.useState("");

  const handleSliderChange = (event) => {
    setCountryVolume({
      ...countryVolume,
      ...{
        [event.target.name]: event.target.value,
      },
    });
    if (event.target.value > 0) {
      setCountryvolumeError(null);
    }
  };

  const handlePickupinputChange = (event) => {
    setPickuppostalcode(event.target.value)
    if (event.target.value.trim() !== "") {
      setPickuppostalcodeError(null);
    }
  };

  const handleInputChange = (event) => {
    setCountryVolume({
      ...countryVolume,
      ...{
        [event.target.name]: event.target.value.replace("%", ""),
      },
    });
  };

  const listOfChips = [
    { id: "0-100 Shipments", name: "0-100 Shipments" },
    { id: "101-500 Shipments", name: "101-500 Shipments" },
    { id: "501-1000 Shipments", name: "501-1000 Shipments" },
    { id: "1001-3000 Shipments", name: "1001-3000 Shipments" },
    { id: "3001-5000 Shipments", name: "3001-5000 Shipments" },
    { id: "5000+ Shipments", name: "5000+ Shipments" },
  ];

  const listOfChipsLogos = [
    { id: "Shopify", name: "shopify" },
    { id: "BigCommerce", name: "bigcommerce" },
    { id: "WooCommerce", name: "woocommerce" },
    { id: "Amazon", name: "amazon" },
    { id: "Magento", name: "magento" },
    { id: "Etsy", name: "etsy" },
    { id: "Other", name: "other" },
  ];
  const [allChips, setAllChips] = React.useState(listOfChips);
  const [selectedVolume, setSelectedVolume] = React.useState("");

  const [selectedStore, setSelectedStore] = React.useState(new Set());

  const [allChipsLogos, setAllChipsLogos] = React.useState(listOfChipsLogos);

  // const [countryShipments, setCountryShipments] = React.useState(listOfChipsLogos);

  function handleSelectionChanged(id) {
    setStoreError(null);
    // treat state as immutable
    // React only does a shallow comparison so we need a new Set
    if (id != "Other") {
      const newSet = new Set(selectedStore);
      if (newSet.has(id)) newSet.delete(id);
      else newSet.add(id);
      setSelectedStore(newSet);
      setOtherStoreVisible(false);
    } else {
      setOtherStoreVisible(true);
    }
  }

  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const profile = useSelector(state => state.profile);
  const orders = useSelector((state) => state.orders);
  const box = useSelector((state) => state.box);
  const newcreateshipment = useSelector((state) => state.createshipment);
  const onboarding = useSelector(
    (state) => state.onboarding && state.onboarding.notificationdata
  );
  const activation = useSelector(
    (state) => state.onboarding && state.onboarding.activation
  );
  const labelsearch = useSelector(
    (state) => state.dashboard && state.dashboard.labelsearch
  );
  const verification = useSelector(
        (state) => state.onboarding && state.onboarding.verification
  );
  const stripeVerification = useSelector(
    (state) => state.onboarding && state.onboarding.stripeVerification
  );
  const departureScanUpdate = useSelector((state) => state.dashboard && state.dashboard.departurescan);
  const country = useSelector((state) => state.countrystate.country);
  const state = useSelector((state) => state.countrystate.state);
  const filteredCountryData = country.data.filter(({ code }) => code);
  const [alert, setAlert] = useState(false);
  const [visible, setVisible] = useState(false);
  const [formDataValues, setFormDataValues] = useState("");
  const [trackingNumber, settrackingNumber] = useState("");
  const [orderpickid, setorderpickid] = useState("");
  const [orderpickidErrors, setoderpickidErrors] = useState(null);
  const [detartureTrackingNumber, setDetartureTrackingNumber] = useState("");
  const [detartureTrackingNumberErrors, setDetartureTrackingNumberErrors] = useState(null);
  const [trackingnumberSubmit, settrackingnumberSubmit] = useState(false);

  const [trackingNumberErrors, setTrackingNumberErrors] = useState(null);
  const [trackingDrawerVisible, setTrackingDrawerVisible] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [newOrderCreateDrawerVisible, setNewOrderCreateDrawerVisible] =
    useState(false);
  const [bulkOrderCreateDrawerVisible, setBulkOrderCreateDrawerVisible] =
    useState(false);
  const [newOrderFormData, setNewOrderFormData] = useState("");
  const [labelPrinted, setLabelPrinted] = useState(false);
  const [printUrl, setPrintUrl] = useState("");
  const [isPrinted, setIsPrinted] = useState(true);
  const [isRateShown, setIsRateShown] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [storeerror, setStoreError] = useState(null);
  const [volumeError, setVolumeError] = useState(null);
  const [pickuppostalcodeError, setPickuppostalcodeError] = useState(null);
  const [orgName, setOrgName] = useState("");
  const [orgNameError, setOrgNameError] = useState(null);
  const [countryvolumeError, setCountryvolumeError] = useState(null);
  const [questionVisible, SetQuestionVisible] = useState(false);
  const [pickupvaluesError, setpickupvaluesError] = useState(null);
  const [isMultiPiece, setIsMultiPiece] = useState(false)
  const [isReturnOrder, setIsReturnOrder] = useState(false);
  const [carrier, setCarrier] = useState("");
  const [storeurl, setStoreurl] = useState("");
  const [pickuppostalcode, setPickuppostalcode] = useState("");
  const [boxData, setBoxData] = useState([])
  const defaultInputRef = useRef(null);
  const [userInteracted, setUserInteracted] = useState(false);
  const [VerificationFormStatus, setVerificationFormStatus] = useState(false);
  const [verificationSessionId, setVerificationSessionId] = useState("");
  const [isCheckingOrg, setIsCheckingOrg] = useState(false);
  const [snackAlert, setSnackAlert] = React.useState({
    open: false,
    vertical: 'top',
    horizontal: 'center',
  });
  const handleSnackAlertClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackAlert({ ...state, open: false });
  };
  const params = new URLSearchParams(window.location.search)
  let urlParam = params.get('verification')

  const initialPickupValues = {
    pickup: false,
    dropoff: false,
  };
  const [pickupValues, setPickupValues] = useState(initialPickupValues);
  const onLabelChange = (e) => {
    const { name, value } = e.target;
    setPickupValues({
      ...pickupValues,
      [name]: e.target.checked,
    });
    if (e.target.checked || (name === 'pickup' ? pickupValues.dropoff : pickupValues.pickup)) {
      setpickupvaluesError(null);
    }
  };

  const [labelSearchValues, setLabelSearchValues] = useState({
    search_by: "order_id",
    search_value: "",
  });
  const [questinerData, setQuestinerData] = useState({
    volume: "",
    country: "",
    store: "",
  });

  const [multipleLabelModalVisible, setMultipleLabelModalVisible] =
    useState(false);
  const [multipleLabelData, setMultipleLabelData] = useState([]);
  const rates = useSelector((state) => state.rates);

  const bulkOrderCreateCallback = (item) => {
    setBulkOrderCreateDrawerVisible(true);
  };
  const bulkOrderCreateOnClose = (values) => {
    setBulkOrderCreateDrawerVisible(false);
  };
  const newOrderCreateCallback = (item) => {
    setNewOrderCreateDrawerVisible(true);
  };
  const newOrderCreateOnClose = (values) => {
    setNewOrderCreateDrawerVisible(false);
  };
  const handleClose = () => {
    setSnackOpen(false);
    dispatch(resetOnboarding());
    dispatch(resetRateState());
  };
  const initialValues = {
    postal_code: "",
    country_code: "",
    province_code: "",
    address1: "",
    address: "dummy address",
    city: "",
    weight: "",
    weight_unit: "lb",
    length: "",
    height: "",
    width: "",
    dimension_unit: "in",
    quantity:1,
    "choosenmeasurement": 0,
    name:"dummy name",
    "request_medium":"UI"
  };

  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState({});


  const [scheduleOpen, setscheduleOpen] = React.useState(false);
  const [verifyOpen, setVerifyOpen] = React.useState(false);

  const scheduleHandleClose = () => {
    setscheduleOpen(false);
    window.location.href =
      window.location.origin + "/integration/marketplace?report=scheduledemo";
  };

  const columns = [
    {
      field: "order_id",
      headerName: "Order Id",
      headerClassName: "super-app-theme--header",
      width: 200,
      renderCell: (params) => {
        if (params.row.order_id) {
          return params.row.order_id;
        } else {
          return "-";
        }
      },
    },
    {
      field: "tracking_number",
      headerName: "Tracking Number",
      headerClassName: "super-app-theme--header",
      width: 200,
      renderCell: (params) => {
        if (params.row.tracking_number) {
          return params.row.tracking_number;
        } else {
          return "-";
        }
      },
    },
    {
      field: "reference_number",
      headerName: "Reference Number",
      headerClassName: "super-app-theme--header",
      width: 200,
      renderCell: (params) => {
        if (params.row.reference_number) {
          return params.row.reference_number;
        } else {
          return "-";
        }
      },
    },
    {
      field: "label_url",
      headerName: "Action",
      headerClassName: "super-app-theme--header",
      width: 100,
      renderCell: (params) => {
        if (params.row.label_url) {
          return (
            <LocalPrintshopIcon
              onClick={() => OpenLabelClose(params.row.label_url)}
              style={{
                color: "#1890ff",
                pointerEvents: "auto",
                cursor: "pointer",
              }}
            />
          );
        } else {
          return "-";
        }
      },
    },
  ];

  const validator = (fieldValues) => {
    let temp = { ...errors };
    if ("postal_code" in fieldValues)
      temp.postal_code = fieldValues.postal_code
        ? ""
        : "This field is required.";
    if (
      fieldValues &&
      fieldValues.postal_code &&
      fieldValues.postal_code.match(/[^0-9a-z]/i)
    ) {
      temp.postal_code = "Postal code only accepts alpha numeric";
    }
    if (
      (fieldValues &&
        fieldValues.postal_code &&
        fieldValues.postal_code.length < 5) ||
      fieldValues.postal_code === null
    )
      temp.postal_code = "Postalcode required minimum 6 characters";
    if ("weight" in fieldValues)
      temp.weight = fieldValues.weight ? "" : "This field is required.";
    if ("weight_unit" in fieldValues)
      temp.weight_unit = fieldValues.weight_unit
        ? ""
        : "This field is required.";
    if ("length" in fieldValues)
      temp.length =
        fieldValues.length && fieldValues.length > 0
          ? ""
          : "length is required and should be valid";
    if ("weight" in fieldValues)
      temp.weight =
        fieldValues.weight && fieldValues.weight > 0
          ? ""
          : "weight is required and should be valid";
    if ("height" in fieldValues)
      temp.height =
        fieldValues.height && fieldValues.height > 0
          ? ""
          : "height is required and should be valid";
    if ("width" in fieldValues)
      temp.width =
        fieldValues.width && fieldValues.width > 0
          ? ""
          : "width is required and should be valid";
    if ("dimension_unit" in fieldValues)
      temp.dimension_unit = fieldValues.dimension_unit
        ? ""
        : "This field is required.";
    if ("country_code" in fieldValues)
      temp.country_code = fieldValues.country_code
        ? ""
        : "This field is required.";
    if (fieldValues && fieldValues.country_code && fieldValues.country_code !== 'CA') {
      if ("address1" in fieldValues)
        temp.address1 = fieldValues.address1 ? "" : "This field is required.";
      if ("city" in fieldValues)
        temp.city = fieldValues.city ? "" : "This field is required.";
    } else {
      temp.address1 = "";
      temp.city = "";
    }
    if (fieldValues && fieldValues.country_code && (fieldValues.country_code === 'CA' || fieldValues.country_code === 'US')) {
      if ("province_code" in fieldValues)
        temp.province_code = fieldValues.province_code ? "" : "This field is required.";
    }

    setErrors({
      ...temp,
    });

    if (fieldValues == values) return Object.values(temp).every((x) => x == "");
  };

  const onInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
    validator({ [name]: value });
  };

  const formatValues = (recommended_rate_only) => {
    let formValues = values;
    formValues["package_dimension"] =
      values.length + "x" + values.width + "x" + values.height;
    formValues["recommended_rate_only"] = recommended_rate_only;
    let line_items = [{
      "line_item_id": "e029ac7d-e577-4079-b8f3-228a2f9b12ec",
      "product_id": 18936,
      "product_desc": "Light Teal - mobile cover",
      "product_url": "https://www.shippingchimp.com/",
      "product_price": 7.99,
      "hs_tariff_code": "",
      "hs_tariff_code_country": "",
      "quantity": 2,
      "tracking_number": "",
      "origin_country_code": ""
    }]
    line_items = JSON.stringify(line_items);
    formValues["line_items"] = line_items;
    return formValues;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const isValid = validator(values);
    if (isValid) {
      let recommended_rate_only = false;
      setVisible(true);
      setIsRateShown(false);
      let apikey = profile.profile.api_token ? profile.profile.api_token : "";
      if (
        profile &&
        profile.profile &&
        profile.profile.hide_rate_drawer === true
      ) {
        recommended_rate_only = true;
        setVisible(false);
        setIsRateShown(true);
      }
      setFormDataValues(values);
      let report="DASHBOARD_FETCH_RATES"
      let orderId=""
      dispatch(doGetRate(report,profile.profile.id,orderId,formatValues(recommended_rate_only), apikey));
    }
  };

  const orderpickValidate = () => {
    if (orderpickid !== "") {
      setoderpickidErrors("");
    }
  }

  const trackOrderHandleSubmit = () => {
    if (orderpickid == "") {
      setoderpickidErrors("Order id is required");
    } else {
      setoderpickidErrors("");
      window.location.href = window.location.origin + "/orders/picklist?orderid=" + orderpickid;
    }
  };

  const onInputClear = () => {
    setDetartureTrackingNumber("");
    settrackingnumberSubmit(false)
  };

  const deperturScanValidate = () => {
    if (detartureTrackingNumber !== "") {
      setDetartureTrackingNumberErrors("");
    }
  }

  const departureScanHandleSubmit = () => {
    if (detartureTrackingNumber == "") {
      setDetartureTrackingNumberErrors("Tracking Number is required");
    } else {
      setDetartureTrackingNumberErrors("");
      let depertureData = {
        "tracking_number": detartureTrackingNumber
      }
      dispatch(departureScan(profile.profile.id,depertureData));
    }
  };


  const validateerror = document.getElementsByClassName("validateErrors");
  if (validateerror) {
    setTimeout(function () {
      SetQuestionVisible(true);
    }, 5000);
  }

  // Function to check duplicate (Add to your component)
 const checkOrgUniqueness = async (name) => {
    // Clean the name before checking
    const cleanName = name
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '') // Removes spaces, dashes, and symbols entirely
        .trim();    
    if (cleanName.length < 3) return;

    setIsCheckingOrg(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_DOMAIN}/api/check-org-availability?org_id=${cleanName}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            // Include this if your Laravel API is protected by Sanctum/Passport
            'Authorization': `Bearer ${profile.profile.api_token}` 
          }
        }
      );
      
      const data = await response.json();
      
      if (data.exists) {
        setOrgNameError("This organisation name is already registered.");
      } else {
        setOrgNameError(null);
      }
    } catch (e) {
      // Optional: setOrgNameError("Could not verify name at this time.");
    } finally {
      setIsCheckingOrg(false);
    }
  };

  // Use an effect to debounce the check
  useEffect(() => {
    // Reset error immediately if name is too short to look professional
    if (orgName.length > 0 && orgName.length < 3) {
      setOrgNameError("Minimum 3 characters required");
    }

    const timer = setTimeout(() => {
      if (orgName.length >= 3) {
        checkOrgUniqueness(orgName);
      }
    }, 600); // 600ms is usually the "sweet spot" for UX

    return () => clearTimeout(timer);
  }, [orgName]);
  const questionHandleSubmit = () => {
    let selectedStores = Array.from(selectedStore);
    if (otherStoreValue != "") {
      selectedStores.push(otherStoreValue);
    }
    const isOrgValid = orgName.trim() !== "" && orgName.length >= 3 && !orgNameError && !isCheckingOrg;
    if (!isOrgValid) {
        if (orgName.length < 3) setOrgNameError("Minimum 3 characters required");
        else if (!orgNameError) setOrgNameError("Please wait for name verification");
        return; // Stop the submission
    }
    if (
      selectedVolume != "" &&
      (isOrgValid && countryVolume.canada != 0 ||
        countryVolume.us != 0 ||
        countryVolume.international != 0) && (pickupValues.dropoff !== false || pickupValues.pickup === true)  && pickuppostalcode !== '' && pickuppostalcode !== null && pickuppostalcodeError === null &&
      Object.keys(selectedStores).length != 0 && (pickupValues.pickup !== false || pickupValues.dropoff !== false)
    ) {
      let questionerData = {}
      questionerData = {
        org_id: orgName,
        volume: selectedVolume,
        country: countryVolume,
        stores: selectedStores,
        carrier: carrier,
        store_url: storeurl,
        pickup: pickupValues.pickup,
        sender_postal_code: pickuppostalcode,
        dropoff: pickupValues.dropoff,
      }
      dispatch(storeQuestionerData(profile.profile.id,questionerData));

      let transaction_value_dict = {
        "0-100 Shipments": "$50",
        "101-500 Shipments": "$250",
        "501-1000 Shipments": "$750",
        "1001-3000 Shipments": "$2000",
        "3001-5000 Shipments": "$4000",
        "5000+ Shipments": "$7500"
      };
      let transaction_value = transaction_value_dict[selectedVolume];
      window.dataLayer.push({ 'transactionValue': transaction_value });
      window.dataLayer.push({ 'event': "Registration_Complete" });
      setDialogOpen(false)
      if(profile &&
        profile.profile &&
        profile.profile.id ===94){
          setVerifyOpen(true)
        }
      
    } else {
      if (!isOrgValid) setOrgNameError("Organization name is required");
      if (
        selectedVolume == "" ||
        selectedVolume == null ||
        selectedVolume == "undefined"
      ) {
        setVolumeError("Please choose your shipment volume");
      } else {
        setVolumeError(null);
      }
      if (
        countryVolume.canada == 0 ||
        countryVolume.us == 0 ||
        countryVolume.international == 0
      ) {
        setCountryvolumeError("Please choose your ship country");
      } else {
        setCountryvolumeError(null);
      }
      if (Object.keys(selectedStores).length == 0) {
        setStoreError("Store required");
      } else {
        setStoreError(null);
      }
      if (pickupValues.pickup == false && pickupValues.dropoff == false) {
        setpickupvaluesError("pickup preference required")
      } else {
        setpickupvaluesError(null);
      }
      const trimmedPostalCode = pickuppostalcode.trim();
      if (trimmedPostalCode === ''  || trimmedPostalCode === null) {
        setPickuppostalcodeError("Your postal code required")
      } else {
        setPickuppostalcodeError(null);
      }
    }
  };

  const onSelectCountryChange = (countryCode) => {
    setValues({
      ...values,
      country_code: countryCode,
    });
    setErrors({ sender_country_code: "" });
    dispatch(fetchState(countryCode));
  };

  const onSearchLabelFieldsChange = (event) => {
    let labelSearchValuesTemp = { ...labelSearchValues };
    labelSearchValuesTemp[event.target.name] = event.target.value;
    setLabelSearchValues(labelSearchValuesTemp);
    if (event.charCode === 13) {
      dispatch(fetchLabelData(labelSearchValuesTemp));
      setLabelPrinted(false);
    }
  };

  const onClose = (values) => {
    setVisible(false);
    setIsRateShown(false);
    // dispatch(resetLabelGeneratedOrder())
  };



  const trackingNumberValidate = (event) => {
    if (event.target.value.trim() == "") {
      setTrackingNumberErrors("Tracking number is required");
    } else if (
      event.target.value.match(
        /[\!\@\#\$\%\^\&\*\)\(\+\=\.\<\>\{\}\[\]\:\;\'\"\|\~\`\_\-]/g
      )
    ) {
      setTrackingNumberErrors("Tracking number is invalid");
    } else {
      setTrackingNumberErrors("");
    }
  };
  const trackHandleSubmit = () => {
    setIsMultiPiece(false)
    if (trackingNumber.trim() == "") {
      setTrackingNumberErrors("Tracking number is required");
    } else if (
      trackingNumber.match(
        /[\!\@\#\$\%\^\&\*\)\(\+\=\.\<\>\{\}\[\]\:\;\'\"\|\~\`\_\-]/g
      )
    ) {
      setTrackingNumberErrors("Tracking number is invalid");
    } else {
      setTrackingNumberErrors("");
      let apikey = profile.profile.api_token ? profile.profile.api_token : "";
      const data = {
        tracking_number: trackingNumber,
      };
      let firstChar = trackingNumber.charAt(0);
      if (firstChar == 'M') {
        setIsMultiPiece(true)
      }
      dispatch(fetchCustomerDetails(data, apikey));
      setTrackingDrawerVisible(true);
    }
  };

  const trackingCallback = (carriername, trackingNumber) => {
    let apikey =
      profile && profile.profile && profile.profile.api_token
        ? profile.profile.api_token
        : "";
    const data = { carrier_name: carriername, tracking_number: trackingNumber };
    dispatch(fetchCustomerDetails(data, apikey));
    setTrackingDrawerVisible(true);
  };
  const trackingDraweronClose = (values) => {
    setTrackingDrawerVisible(false);
  };

  const handleRequest = () => {
    dispatch(useraccountactivate());
  };
  useEffect(() => {
    if (activation && activation.message) {
      setAlert(true);
      setSnackOpen(true);
      dispatch(fetchOnboardingData());
    } else if (activation && activation.hasErrors == true) {
      setAlert(true);
      setSnackOpen(true);
    }
  }, [dispatch, activation && activation.message]);

  useEffect(() => {
    dispatch(fetchOnboardingData());
    dispatch(fetchCountry());
    dispatch(fetchProfile())
    dispatch(fetchBoxData(false));
  }, [dispatch]);

  useEffect(() => {
    if (rates && rates.message && rates.message.length !== 0) {
      setSnackOpen(true);
    }
  }, [rates]);

  useEffect(() => {
    if (box && box.data && box.data.length !== 0) {
      box.data.map((item) => {
        if (item.box_default === true) {
          setValues({
            ...values,
            "length": parseFloat(item.box_length).toFixed(2),
            "width": parseFloat(item.box_width).toFixed(2),
            "height": parseFloat(item.box_height).toFixed(2),
            "dimension_unit": item.box_length_unit,
            "weight": parseFloat(item.box_weight).toFixed(2),
            "weight_unit": item.box_weight_unit,
            "choosenmeasurement": item._id,
          })
        }
      })
    }
  }, [box && box.data]);

  useEffect(() => {
    if (departureScanUpdate && departureScanUpdate.notification && departureScanUpdate.notification.messageContent
      && departureScanUpdate.notification.messageContent[0] === 'Departure Scan updated successfully') {
      setDetartureTrackingNumber("");
      settrackingnumberSubmit(false)
    }
  }, [departureScanUpdate]);

  const handleMultiPackageDimensionInputChange = (event) => {
    if (event.target.name == "choosenmeasurement") {
      if (event.target.value != 0) {
        box && box.data && box.data.map((boxData) => {
          if (boxData._id === event.target.value) {
            setValues({
              ...values,
              "length": parseFloat(boxData.box_length).toFixed(2),
              "width": parseFloat(boxData.box_width).toFixed(2),
              "height": parseFloat(boxData.box_height).toFixed(2),
              "dimension_unit": boxData.box_length_unit,
              "weight": parseFloat(boxData.box_weight).toFixed(2),
              "weight_unit": boxData.box_weight_unit,
              "choosenmeasurement": event.target.value,
            })
            setErrors({
              ...errors,
              "length": "",
              "width": "",
              "height": "",
              "weight": "",
            })
          }
        })
      } else {
        setValues({
          ...values,
          "length": "",
          "width": "",
          "height": "",
          "dimension_unit": "in",
          "weight": "",
          "weight_unit": "lb",
          "choosenmeasurement": 0,
        })
      }
    }
  }

  const filterOptions = createFilterOptions({
    matchFrom: 'start',
    stringify: (option) => option.box_name,
  });

  const getChooseMeasurement = (currentvalue) => {
    let filteredCurrentValue = {};
    let tempValue = "";
    boxData &&
      boxData.map((key) => {
        if (key._id == currentvalue && tempValue == "") {
          filteredCurrentValue = key;
          tempValue = "success";
        }
      });
    return filteredCurrentValue;
  };

  useEffect(() => {
    let tempBoxData = []
    let customValue = { "_id": 0, "box_name": "custom" }
    tempBoxData.push(customValue)
    let boxOriginalData = box && box.data.filter(function (obj) {
      return obj.hide !== true;
    });
    if (boxOriginalData.length !== 0) {
      boxOriginalData.map((item) => {
        tempBoxData.push(item)
      })
      setBoxData(tempBoxData)
    } else {
      setBoxData(tempBoxData)
    }
  }, [box]);

  useEffect(() => {
    if (Object.keys(profile && profile.profile).length !== 0) {
      if (profile && profile.profile && profile.profile.questioner_data || profile.profile.id !== profile.profile.parent_id) {
        setDialogOpen(false);
        setVerifyOpen(false);
      } else if (
        profile &&
        profile.notification &&
        profile.notification &&
        profile.notification.messageContent != ""
      ) {
        setDialogOpen(false);
      } else {
        setDialogOpen(true);
      }
      if(profile && profile.profile &&  (typeof profile.profile.is_user_form_verfication_status!=='undefined' || profile.profile.verification_status && profile.profile.verification_status==='VERIFIED')){
        setVerifyOpen(false);
      }else{
        if(profile &&
          profile.profile &&
          profile.profile.id  ===94){
            setVerifyOpen(true);
          }
      }
    }
  }, [profile]);

  useEffect(() => {
    if (
      (orders &&
        orders.createShipment &&
        orders.createShipment.notification &&
        orders.createShipment.notification.show &&
        orders.createShipment.notification.messageType === "success") ||
      (newcreateshipment &&
        newcreateshipment.notification &&
        newcreateshipment.notification.show &&
        newcreateshipment.notification.messageType === "success")
    ) {
      const delayDebounceFn = setTimeout(() => {
        window.location.href = window.location.origin + "/orders/all";
      }, 1000);
    }
  }, [orders]);

  const OpenLabelClose = (label_url) => {
    setPrintUrl(label_url);
    setIsPrinted(false);
  };

  const onLabelModalClose = () => {
    let labelSearchValuesTemp = { ...labelSearchValues };
    labelSearchValuesTemp[`search_value`] = "";
    setLabelSearchValues(labelSearchValuesTemp);
    setLabelPrinted(true);
    setMultipleLabelModalVisible(false);
    dispatch(resetLabelData());
  };

  const formatRate = () => {
    let estimatedRate = "-"
    if(rates && rates.data && Array.isArray(rates.data) && rates.data.length > 0){
        estimatedRate = (rates.data[0] && rates.data[0].total_charges) ? rates.data[0].total_charges : "-"
    }
    return estimatedRate
  };

  useEffect(() => {
    if (
        labelsearch &&
        labelsearch.label &&
        Array.isArray(labelsearch.label) &&
        labelsearch.label.length !== 0 &&
        labelPrinted === false
    ) {
        let printed = false;
        let multipleLabelDataTemp = [];

        labelsearch.label.forEach((piece) => {
            // In ShipmentsPiecesReadCollection, the label object is at the root
            const labelObj = piece.label;

            if (labelObj) {
                // Determine the correct Label URL based on priority
                let labelUrl = "";
                if (labelObj.url_detachable && labelObj.url_detachable !== "") {
                    labelUrl = labelObj.url_detachable;
                } else if (labelObj.url_direct_detachable && labelObj.url_direct_detachable !== "") {
                    labelUrl = labelObj.url_direct_detachable;
                } else if (labelObj.url && labelObj.url !== "") {
                    labelUrl = labelObj.url;
                } else if (labelObj.url_direct && labelObj.url_direct !== "") {
                    labelUrl = labelObj.url_direct;
                }

                if (labelUrl !== "") {
                    if (labelsearch.label.length === 1) {
                        // Single label logic
                        OpenLabelClose(labelUrl);
                        printed = true;
                    } else {
                        // Multiple labels logic - Map root fields from ShipmentsPieces
                        multipleLabelDataTemp.push({
                            order_id: piece.order_id || "",
                            tracking_number: piece.tracking_number || "",
                            reference_number: piece.reference?.no || "",
                            label_url: labelUrl,
                        });
                    }
                }
            }
        });

        // Show modal if multiple pieces found
        if (multipleLabelDataTemp.length !== 0) {
            setMultipleLabelData(multipleLabelDataTemp);
            setMultipleLabelModalVisible(true);
        }

        // Clean up if a single label was printed
        if (printed === true) {
            let labelSearchValuesTemp = { ...labelSearchValues };
            labelSearchValuesTemp[`search_value`] = "";
            setLabelSearchValues(labelSearchValuesTemp);
            setLabelPrinted(true);
            dispatch(resetLabelData());
        }
    }
  }, [labelsearch]);

  useEffect(() => {
    // Set default focus only on component mount
    if (defaultInputRef.current && !userInteracted) {
      defaultInputRef.current.focus();
    }
  }, [userInteracted]);

  const handleFocus = (isDefault) => {
    if (!isDefault) {
      setUserInteracted(true); // Stop focusing default input if user clicks another input
    }
  };

  const onBusinessVerificationClose = (status) => {
    if(status==="filled"){
      setVerificationFormStatus(false)
      setVerifyOpen(false)
    }else{
      setVerificationFormStatus(false)
    }
  }
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

  useEffect(() => {
    let sessionVerification = new URLSearchParams(window.location.search).get("verification");
    if (sessionVerification!==null) {
      let sessionId = localStorage.getItem("verification_session_id");
      let data={"sessionId" :sessionId} // ✅ Fallback to stored session
      setVerificationSessionId(sessionId)
      dispatch(stripeuseraccountVerification(profile.profile.id,sessionId))
    }
  }, []);

  useEffect(() => {
    if (stripeVerification && stripeVerification.notification && stripeVerification.notification.messageContent && stripeVerification.notification.messageContent.length>0 && stripeVerification.notification.messageContent[0]==='verified') {
      setVerifyOpen(false)
      setscheduleOpen(true)
    }
  }, [stripeVerification]);
  
  return (
    <>
      {activation && activation.loading === true && (
        <>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </>
      )}
      {newcreateshipment &&
        newcreateshipment.notification &&
        newcreateshipment.notification.show &&
        newcreateshipment.notification.messageType !== "success" && (
          <Notification
            is_open={newcreateshipment.notification.show}
            messageType={newcreateshipment.notification.messageType}
            messages={newcreateshipment.notification.messageContent}
            handleClose={() => dispatch(resetGenerateLabel())}
          />
        )}
      {auth && auth.notification && auth.notification.show && (
        <Notification
          is_open={auth.notification.show}
          messageType={auth.notification.messageType}
          messages={auth.notification.messageContent}
        handleClose={() => dispatch(resetNotification())}
        />
      )}
      {profile && profile.notification && profile.notification.shw && (
        <Notification
          is_open={profile.notification.show}
          messageType={profile.notification.messageType}
          messages={profile.notification.messageContent}
        // handleClose={() => dispatch(resetOrderNotifications())}
        />
      )}
      {orders &&
        orders.createShipment.notification &&
        orders.createShipment.notification.show && (
          <Notification
            is_open={orders.createShipment.notification.show}
            messageType={orders.createShipment.notification.messageType}
            messages={orders.createShipment.notification.messageContent}
            handleClose={() => dispatch(resetOrderNotifications())}
          />
        )}
      {departureScanUpdate &&
        departureScanUpdate.notification &&
        departureScanUpdate.notification.show && (
          <Notification
            is_open={departureScanUpdate.notification.show}
            messageType={departureScanUpdate.notification.messageType}
            messages={departureScanUpdate.notification.messageContent}
            handleClose={() => dispatch(resetLabelData())}
          />
        )}
      {verification &&
        verification.notification &&
        verification.notification.show && (
          <Notification
            is_open={verification.notification.show}
            messageType={verification.notification.messageType}
            messages={verification.notification.messageContent}
            handleClose={() => dispatch(resetOnboarding())}
          />
        )}
        {snackAlert &&
          <Snackbar
              open={snackAlert.open}
              anchorOrigin={{ vertical:"top", horizontal:'center' }}
              autoHideDuration={5000}
              onClose={handleSnackAlertClose}
              >
              <Alert
                severity={"success"}
              >
                We are currently processing your business verification. Please wait for further updates.
              </Alert>
            </Snackbar>
          }
                {alert && (
        <Snackbar
          open={snackOpen}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <Alert
            severity={
              activation && activation.hasErrors === true ? "error" : "success"
            }
            style={{ justifyContent: "center", margin: "10px 0" }}
          >
            <span> {activation && activation.message}</span>
          </Alert>
        </Snackbar>
      )}
      {snackAlert.open && (
        <div className="sc--cardhead--details">
          <Notification
            is_open={snackOpen}
            messageType={rates.hasErrors == true ? "error" : "success"}
            messages={rates.message}
            handleClose={handleClose}
          />
        </div>
      )}
      <Printer
        isPrinted={isPrinted}
        setIsPrinted={setIsPrinted}
        print_url={printUrl}
        closable={true}
      />
      <Modal
        open={
          labelsearch &&
          labelsearch.loading == false &&
          multipleLabelModalVisible
        }
        onClose={onLabelModalClose}
      >
        <Box sx={modalStyleLabel}>
          <h2>
            {
              labelSearchValues["search_by"].replace("_", " ") +
              " " +
              labelSearchValues["search_value"]}
          </h2>
          <div className="sc--form--center" style={{ margin: "20px 0" }}>
            <DataGrid
              getRowId={(row) =>
                Math.random() + Math.random() + row.tracking_number
              }
              rows={multipleLabelData}
              pageSize={5}
              columns={columns}
              autoHeight={true}
              disableColumnFilter={true}
              disableColumnMenu={true}
              disableSelectionOnClick={true}
            />
          </div>
        </Box>
      </Modal>
      <Modal
        open={
          labelsearch &&
          labelsearch.loading == false &&
          labelsearch.hasErrors == true &&
          labelsearch.message != ""
        }
      >
        <Box sx={modalStyle}>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <div style={{ textAlign: "center" }}>
              {labelsearch &&
                labelsearch.loading == false &&
                labelsearch.hasErrors == true &&
                labelsearch.message != "" &&
                labelsearch.message}
            </div>
            <div style={{ textAlign: "center", marginTop: "10px" }}>
              <Button
                variant="outlined"
                onClick={() => dispatch(resetLabelData())}
              >
                OK
              </Button>
            </div>
          </Typography>
        </Box>
      </Modal>
      <div>
        <Dialog
          keepMounted
          open={
            verifyOpen
          }
          
          // onClose={scheduleHandleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          sx={{ "& .MuiDialog-paper": { maxWidth: "800px" } }}
        >
          {/* <DialogTitle style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0px 24px 0px 35px', marginTop: '20px' }}>
            <h6 style={{ textAlign: 'center', fontSize: '20px', margin: '10px 0', padding: '0 25px' }}>Business Verification</h6>
            <IconButton onClick={scheduleHandleClose}>
              <CloseOutlinedIcon onClick={scheduleHandleClose} />
            </IconButton>
          </DialogTitle> */}
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Typography sx={{ mb: 1, padding: '10px 30px', textAlign: 'center' }}>To ensure a secure shipping experience, we verify your ID for authenticity. Rest assured, your personal data won't be stored. 
              <Stack direction="row" spacing={2} style={{justifyContent:'center',marginTop:'20px'}}>
                  {/* Personal ID Verification Button */}
                  <VerifyButton stripePromise={stripePromise} />
                  {/* <CustomButton href="https://verify.stripe.com/v/14kaIsbGJ86QaeA8ww" startIcon={<PersonIcon style={{ color: "#fff" }} />}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                      <span>Verify using your personal ID</span>
                      <span style={{ fontSize: "12px", opacity: 0.7 }}>(Instant Verification)</span>
                    </div>
                  </CustomButton> */}

                  {/* Business Verification Button */}
                  <CustomButton startIcon={<BusinessIcon style={{ color: "#fff" }} />} onClick={(e)=>{
                    setVerificationFormStatus(true)
                  }}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                      <span>Verify using business incorporation details</span>
                      <span style={{ fontSize: "12px", opacity: 0.7 }}>(takes up to 24 hours to activate)</span>
                    </div>
                  </CustomButton>
                </Stack>
              </Typography>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </div>
        <BusinessVerification VerificationFormStatus={VerificationFormStatus} onClose={onBusinessVerificationClose}/>
      <div>
        <Dialog
          keepMounted
          open={
            scheduleOpen
          }
          onClose={scheduleHandleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0px 24px 0px 35px', marginTop: '20px' }}>
            <h6 style={{ textAlign: 'center', fontSize: '20px', margin: '10px 0', padding: '0 45px' }}>Would you like to schedule a quick call?</h6>
            <IconButton onClick={scheduleHandleClose}>
              <CloseOutlinedIcon onClick={scheduleHandleClose} />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Typography sx={{ mb: 1, padding: '10px 30px', textAlign: 'center' }}>We would love to give you a walkthrough of our platform and answer all your questions.
                <div style={{ textAlign: 'center' }}><Link to={{ pathname: "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ1zZ8qhs6dpVoGQ53GUA-TU39VuoVvdypM5AeiiibgPmgd4CzgnBgM972phfZso-7OgiNr57mnZ?pli=1?name=" + profile.profile.name + "&email=" + profile.profile.email }} target="_blank"><Button
                  variant="outlined"
                  color="primary"
                  style={{ marginRight: "15px", marginTop: "15px", cursor: "pointer" }}
                >
                  <CalendarMonthOutlinedIcon
                    style={{
                      paddingRight: "10px",
                    }}
                  />
                  Schedule a call
                </Button></Link>
                </div>
              </Typography>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </div>
      <div>
        <Dialog
          keepMounted
          // onClose={handleClose}
          open={dialogOpen}
          aria-describedby="alert-dialog-slide-description"
          className="trial__form__dialog"
        >
          <DialogTitle>
            {"You Made it! Lets Tailor your ShippingChimp experience"}
            <span className="trial__form__wavinghand">
              <img src="/assets/images/trial-form/waving-hand-emoji.png" />
            </span>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <div>
                <p>1. Enter your organization name?</p>
                <div className="sc--form--center" style={{ justifyContent: 'left', marginBottom: '20px' }}>
                 <TextField
                      label="ORGANISATION_NAME"
                      name="orgName"
                      variant="standard"
                      value={orgName}
                      autoComplete="off"
                      onChange={(e) => {
                          const formatted = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
                          setOrgName(formatted);
                          setOrgNameError(null); // Clear error immediately while typing
                      }}
                      error={!!orgNameError}
                      helperText={isCheckingOrg ? "Checking availability..." : orgNameError}
                      InputProps={{
                          endAdornment: isCheckingOrg ? <CircularProgress size={16} /> : null
                      }}
                      style={{ width: "100%", margin: '8px' }}
                  />
                </div>
                <p>2. What was your shipping volume in the previous month?</p>

                <p>
                  <React.Fragment>
                    {allChips.map((c) => (
                      <Chip
                        key={c.id}
                        onClick={() => {
                          setSelectedVolume(c.id);
                          // HIDE ERROR WHEN SELECTED
                          setVolumeError(null);
                        }}
                        variant={selectedVolume == c.id ? "filled" : "outlined"}
                        label={c.name}
                        color="primary"
                      ></Chip>
                    ))}
                  </React.Fragment>
                </p>
                {/* {!questionVisible && <> {volumeError && <p className="validateErrors" style={{ color: 'red' }}>{volumeError}</p>}</>} */}
                {volumeError && <p style={{ color: "#d32f2f", fontSize: '12px' }}>{volumeError}</p>}
                <p style={{ marginTop: "50px" }}>3. Where do you ship to?</p>
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  style={{ width: "60%" }}
                >
                  <Grid item>
                    <Typography gutterBottom variant="p" component="div">
                      Within Canada
                    </Typography>
                  </Grid>
                  <Grid item xs>
                    <Slider
                      name="canada"
                      value={countryVolume.canada}
                      onChange={handleSliderChange}
                      aria-labelledby="input-slider"
                    />
                  </Grid>
                  <Grid item>
                    <Input
                      name="canada"
                      value={countryVolume.canada + "%"}
                      size="small"
                      onChange={handleInputChange}
                      inputProps={{
                        step: 10,
                        min: 0,
                        max: 100,
                        type: "text",
                        "aria-labelledby": "input-slider",
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  style={{ width: "60%" }}
                >
                  <Grid item>
                    <Typography gutterBottom variant="p" component="div">
                      Canada to US
                    </Typography>
                  </Grid>
                  <Grid item xs>
                    <Slider
                      name="us"
                      value={countryVolume.us}
                      onChange={handleSliderChange}
                      aria-labelledby="input-slider"
                    />
                  </Grid>
                  <Grid item>
                    <Input
                      name="us"
                      value={countryVolume.us + "%"}
                      size="small"
                      onChange={handleInputChange}
                      inputProps={{
                        step: 10,
                        min: 0,
                        max: 100,
                        type: "text",
                        "aria-labelledby": "input-slider",
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  style={{ width: "60%" }}
                >
                  <Grid item>
                    <Typography gutterBottom variant="p" component="div">
                      Internationally
                    </Typography>
                  </Grid>
                  <Grid item xs>
                    <Slider
                      name="international"
                      value={countryVolume.international}
                      onChange={handleSliderChange}
                      aria-labelledby="input-slider"
                    />
                  </Grid>
                  <Grid item>
                    <Input
                      name="international"
                      value={countryVolume.international + "%"}
                      size="small"
                      onChange={handleInputChange}
                      inputProps={{
                        step: 10,
                        min: 0,
                        max: 100,
                        type: "text",
                        "aria-labelledby": "input-slider",
                      }}
                    />
                  </Grid>
                </Grid>
                {/* {!questionVisible && <> {countryvolumeError && <p className="validateErrors" style={{ color: 'red' }}>{countryvolumeError}</p>}</>} */}
                {countryvolumeError && (
                  <p style={{ color: "#d32f2f", fontSize: '12px' }}>{countryvolumeError}</p>
                )}
                <p style={{ marginTop: "50px" }}>
                  4. What is your current shipping carrier?
                  <div className="sc--form--center" style={{ justifyContent: 'left' }}>
                    <TextField
                      label="carrier"
                      name="carrier"
                      inputProps={{ maxLength: 35 }}
                      onChange={(e) => {
                        setCarrier(e.target.value);
                      }}
                      variant="standard" style={{ width: "50%", margin: '8px' }}
                    />
                  </div>
                </p>
                <p style={{ marginTop: "50px" }}>
                  5. What is your store URL?
                  <div className="sc--form--center" style={{ justifyContent: 'left' }}>
                    <TextField
                      label="store URL"
                      name="store_url"
                      inputProps={{ maxLength: 35 }}
                      onChange={(e) => {
                        setStoreurl(e.target.value);
                      }}
                      variant="standard" style={{ width: "50%", margin: '8px' }}
                    />
                  </div>
                </p>
                <p style={{ marginTop: "50px" }}>
                  6. Which store front do you use?
                </p>
                {/* <p ><span className='trial__form__chip'><Chip icon={<img alt="shopify" src="/assets/images/trial-form/shopify.png" style={{maxWidth:'85px',padding:'0 5px'}}/>} color="primary" variant="outlined" /></span> <span className='trial__form__chip'><Chip icon={<img alt="bigcommerce" src="/assets/images/trial-form/bigcommerce.png" style={{maxWidth:'85px',padding:'0 5px'}}/>} color="primary" variant="outlined" /></span> <span className='trial__form__chip'><Chip  icon={<img alt="woocommerce" src="/assets/images/trial-form/woocommerce.png" style={{maxWidth:'85px',padding:'0 5px'}}/>} color="primary" variant="outlined" /></span><span style={{padding:'0 5px'}} className='trial__form__chip'><Chip icon={<img alt="amazon" src="/assets/images/trial-form/amazon.png" style={{maxWidth:'85px',padding:'0 5px'}}/>} color="primary" variant="outlined" />
                        </span>
                       <span className='trial__form__chip'><Chip icon={<img alt="magento" src="/assets/images/trial-form/magento.png" style={{maxWidth:'85px',padding:'0 5px'}}/>} color="primary" variant="outlined" style={{paddingRight:'unset'}}/></span><span style={{padding:'0 5px'}} className='trial__form__chip'><Chip icon={<img alt="etsy" src="/assets/images/trial-form/etsy.png" style={{maxWidth:'60px',padding:'0 5px'}}/>} color="primary" variant="outlined"  /></span><span><Chip label="Others" color="primary" variant="outlined" /></span></p> */}
                <p>
                  <React.Fragment>
                    {listOfChipsLogos.map((c) => (
                      <Chip
                        key={c.id}
                        onClick={() => handleSelectionChanged(c.id)}
                        variant={
                          selectedStore.has(c.id) ? "filled" : "outlined"
                        }
                        color="primary"
                        icon={
                          <img
                            alt={c.name}
                            src={`/assets/images/trial-form/${c.name}.png`}
                            style={{ maxWidth: "85px", padding: "0 5px" }}
                          />
                        }
                      ></Chip>
                    ))}
                  </React.Fragment>
                </p>
                {otherStoreVisible && (
                  <TextField
                    label="Other"
                    variant="standard"
                    name="other_store"
                    type="text"
                    inputProps={{ min: 1 }}
                    value={otherStoreValue}
                    onChange={(event) => {
                      setOtherStoreValue(event.target.value);
                    }}
                    style={{ width: "100%" }}
                  />
                )}
                {storeerror && <p style={{ color: "#d32f2f", fontSize: '12px' }}>{storeerror}</p>}

                <p style={{ marginTop: "50px" }}>7. Your Pickup Preference?</p>
                <div
                  className="sc--form--center"
                  style={{ justifyContent: "flex-start" }}
                >
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={pickupValues.pickup}
                          name="pickup"
                          onChange={onLabelChange}
                        />
                      }
                      label="Pick up"
                      labelPlacement="end"
                    />
                  </FormGroup>

                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={pickupValues.dropoff}
                          name="dropoff"
                          onChange={onLabelChange}
                        />
                      }
                      label="Drop off"
                      labelPlacement="end"
                    />
                  </FormGroup>
                </div>
                {pickupvaluesError && <p style={{ color: "#d32f2f", fontSize: '12px' }}>{pickupvaluesError}</p>}
                <div className="sc--form--center" style={{ justifyContent: 'left' }}>
                  <TextField
                    label="Your Postal Code"
                    variant="standard"
                    name="pickup_postal_code"
                    type="text"
                    inputProps={{ min: 1 }}
                    style={{ width: "50%" }}
                    onChange={handlePickupinputChange}
                    error={pickuppostalcodeError}
                    helperText={pickuppostalcodeError}
                  />
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            {/* <Button onClick={handleClose}>Disagree</Button> */}
            <LoadingButton
              onClick={questionHandleSubmit}
              variant="contained"
              // Check auth.loginLoading from your selector
              loading={auth && auth.loginLoading}
              // Optional: Add a loading indicator style/icon
              loadingPosition="start" 
              style={{ display: "flex", margin: "10px auto" }}
            >
              Submit
            </LoadingButton>
          </DialogActions>
        </Dialog>
      </div>
      
      <Typography variant="h5" gutterBottom component="div">
        <div>Hello {profile.profile.name}, Welcome back!</div>
      </Typography>
      <p>Quick Links</p>
      <Grid container spacing={1}>
        <Grid
          item
          xs={12}
          md={4}
          style={{ padding: "10px", cursor: "pointer" }}
        >
          <Item
            className="sc--dashboard--item"
            onClick={newOrderCreateCallback}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "11px 0px",
              }}
            >
              <AddBoxOutlinedIcon sx={Iconstyle} />
              <div>
                <h4 style={{ margin: "unset", textAlign: "left" }}>
                  Create Order
                </h4>
                <p style={{ paddingTop: 6, margin: "unset" }}>
                  Create new shipment using the create order option
                </p>
              </div>
            </div>
          </Item>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
          style={{ padding: "10px", cursor: "pointer" }}
        >
          <Item
            className="sc--dashboard--item"
            onClick={bulkOrderCreateCallback}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "11px 0px",
              }}
            >
              <UploadFileOutlinedIcon sx={Iconstyle} />
              <div>
                <h4 style={{ margin: "unset", textAlign: "left" }}>
                  Import Bulk Order
                </h4>
                <p style={{ paddingTop: 6, margin: "unset" }}>
                  Create multiple shipment using the import bulk order option
                </p>
              </div>
            </div>
          </Item>
        </Grid>
        <Grid item xs={12} md={4} style={{ padding: "10px" }}>
          <Link
            to="/integration/marketplace"
            style={{ textDecoration: "none" }}
          >
            <Item className="sc--dashboard--item">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "11px 0px",
                }}
              >
                <StorefrontOutlinedIcon sx={Iconstyle} />
                <div>
                  <h4 style={{ margin: "unset", textAlign: "left" }}>
                    Integration
                  </h4>
                  <p style={{ paddingTop: 6, margin: "unset" }}>
                    Create shipment for the orders of integrated platform
                  </p>
                </div>
              </div>
            </Item>
          </Link>
        </Grid>
      </Grid>

      <p>ShippingChimp Dashboard</p>
      {/* <Grid container direction="row" spacing={1}> */}
      {/* <Grid item xs={12} sm={12} md={12} lg={8} style={{ padding: '10px' }}> */}
      <Grid container direction="row" spacing={1}>
        <Grid item xs={12} md={3} style={{ padding: "10px" }}>
          <Item style={{ height: "unset" }}>
            <h4 style={{ margin: "unset" }}>
              Tracking
            </h4>
            <Grid
              container
              direction="row"
              alignItems="center"
              spacing={1}
              sx={{ mb: 2 }}
            >
              <Grid xs={12} sm={12} md={12} lg={8} style={{ padding: "0px 10px" }}>
                <TextField
                  id="input-with-icon-textfield"
                  name="tracking_number"
                  label="Tracking number"
                  variant="standard"
                  onChange={(e) => {
                    settrackingNumber(e.target.value);
                  }}
                  style={{ width: "100%", margin: "12px 0" }}
                  onKeyUp={trackingNumberValidate}
                  error={trackingNumberErrors}
                  helperText={trackingNumberErrors}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={3}>
                <Button
                  variant="outlined"
                  sx={{ mt: 2, ml: 2, width: "100%" }}
                  onClick={trackHandleSubmit}
                >
                  Track
                </Button>
              </Grid>
            </Grid>
          </Item>
        </Grid>
        <Grid item xs={12} md={3} style={{ padding: "10px" }}>
          <Item style={{ height: "unset" }}>
            <h4 style={{ margin: "unset" }}>Scan and Print Label</h4>
            {labelsearch && labelsearch.loading === true && (
              <Grid item xs={12} md={12}>
                <LinearProgress />
              </Grid>
            )}
            <Grid
              container
              direction="row"
              alignItems="center"
              spacing={1}
              style={{ margin: "12px 0" }}
            >
              <Grid item xs={12} sm={12} md={6} lg={5}>
                <FormControl variant="standard" style={{ width: "100%" }}>
                  <Select
                    name="search_by"
                    onChange={onSearchLabelFieldsChange}
                    value={labelSearchValues.search_by}
                    label="Search By"
                    style={{ width: "100%", marginTop: "13px" }}
                  >
                    <MenuItem value="order_id">Order Id</MenuItem>
                    <MenuItem value="tracking_number">Tracking Number</MenuItem>
                    <MenuItem value="reference_number">
                      Reference Number
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  placeholder={
                    "Enter " + labelSearchValues.search_by.replace("_", " ")
                  }
                  label={labelSearchValues.search_by.replace("_", " ")}
                  variant="standard"
                  name="search_value"
                  value={labelSearchValues.search_value}
                  inputProps={{ min: 2, maxLength: 25 }}
                  onChange={onSearchLabelFieldsChange}
                  onKeyPress={onSearchLabelFieldsChange}
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>
          </Item>
        </Grid>

        <Grid item xs={12} md={3} style={{ padding: "10px" }}>
          <Item style={{ height: "unset" }}>
            <h4 style={{ margin: "unset", paddingBottom: "5px" }}>
              Departure Scan
            </h4>
            {departureScanUpdate && departureScanUpdate.loading === true && (
              <Grid item xs={12} md={12}>
                <LinearProgress />
              </Grid>
            )}
            <Grid
              container
              direction="row"
              alignItems="center"
              spacing={1}
              sx={{ mb: 2 }}
            >
              <Grid xs={12} sm={12} md={12} lg={8} style={{ padding: "0px 10px" }}>
                <TextField
                  id="input-with-icon-textfield"
                  name="departure_tracking_number"
                  label="Tracking Number"
                  variant="standard"
                  value={detartureTrackingNumber}
                  // onChange={(e) => {
                  //   setDetartureTrackingNumber(e.target.value);
                  // }}
                  onInput={(e) => {
                    setDetartureTrackingNumber(e.target.value)
                    settrackingnumberSubmit(false)
                  }}
                  InputProps={{
                    endAdornment: detartureTrackingNumber ? (
                      <IconButton size="small" onClick={() => onInputClear()}>
                        <ClearIcon />
                      </IconButton>
                    ) : undefined,
                  }}
                  onKeyUp={(event) => {
                    if (event.key == "Enter") {
                      departureScanHandleSubmit();
                    } else {
                      deperturScanValidate()
                    }
                  }}
                  inputRef={defaultInputRef}
                  onFocus={() => handleFocus(true)}
                  style={{ width: "100%", margin: "10px 0" }}
                  error={detartureTrackingNumberErrors}
                  helperText={detartureTrackingNumberErrors}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={3}>
                <Button
                  variant="outlined"
                  sx={{ mt: 2, ml: 2, width: "100%" }}
                  onClick={departureScanHandleSubmit}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Item>
        </Grid>

        <Grid item xs={12} md={3} style={{ padding: "10px" }}>
          <Item style={{ height: "unset" }}>
            <h4 style={{ margin: "unset", paddingBottom: "5px" }}>
              Order Picklist
            </h4>
            <Grid
              container
              direction="row"
              alignItems="center"
              spacing={1}
              sx={{ mb: 2 }}
            >
              <Grid xs={12} sm={12} md={12} lg={8} style={{ padding: "0px 10px" }}>
                <TextField
                  id="input-with-icon-textfield"
                  name="order_id"
                  label="Order Id"
                  variant="standard"
                  onChange={(e) => {
                    setorderpickid(e.target.value);
                  }}
                  onKeyUp={(event) => {
                    if (event.key == "Enter") {
                      trackOrderHandleSubmit();
                    } else {
                      orderpickValidate()
                    }
                  }}
                  style={{ width: "100%", margin: "10px 0" }}
                  error={orderpickidErrors}
                  helperText={orderpickidErrors}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={3}>
                <Button
                  variant="outlined"
                  sx={{ mt: 2, ml: 2, width: "100%" }}
                  onClick={trackOrderHandleSubmit}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Item>
        </Grid>
      </Grid>
      <Grid container direction="row" spacing={1}>
        <Grid item xs={12} sm={12} md={12} lg={8} style={{ padding: "10px" }}>
          <Grid item xs={12} md={12}>
            <Item>
              {/* <Grid item xs={12} md={12}> */}
              <h4 style={{ margin: "unset", paddingBottom: "5px" }}>
                Rate Calculator
              </h4>
              <p style={{ margin: "unset", paddingBottom: "5px" }}>
                Get an estimate with our shipping calculator!
              </p>
              <div className="sc--form--center" style={{ margin: '20px 0' }}>
                <Autocomplete
                  className="help-text-error"
                  disablePortal
                  name="choosenmeasurement"
                  id="state-select-demo"
                  sx={{ width: "100%", margin: '8px' }}
                  options={boxData}
                  autoHighlight
                  loading={
                    (box && box.loading)
                  }
                  getOptionLabel={(option) => option.box_name == 'custom' ? "" + option.box_name + "" : ("" + option.box_name + " (" + option.box_length + option.box_length_unit + "x " + option.box_width + option.box_width_unit + "x " + option.box_height + option.box_height_unit + ", " + option.box_weight + option.box_weight_unit + ")")}
                  filterOptions={filterOptions}
                  value={getChooseMeasurement(values.choosenmeasurement)}
                  renderOption={(props, option) => (
                    <MenuItem {...props} value={option._id} key={option._id}>
                      {option.box_name == 'custom' ?
                        <p style={{ margin: 'unset', color: 'rgba(0, 0, 0, 0.87)' }}>
                          {option.box_name}
                        </p> :
                        <p style={{ margin: 'unset', color: 'rgba(0, 0, 0, 0.87)' }}>
                          {option.box_name}(
                          {option.box_length}{option.box_length_unit} <span style={{ color: '#0082ff' }}> x </span>
                          {option.box_width}{option.box_width_unit} <span style={{ color: '#0082ff' }}> x </span>
                          {option.box_height}{option.box_height_unit}<span>, </span>
                          {option.box_weight}{option.box_weight_unit})
                        </p>}
                    </MenuItem>
                  )}
                  onChange={(event, value) => {
                    if (value !== null) {
                      let event = {
                        "target": {
                          "name": "choosenmeasurement",
                          "value": value._id
                        }
                      }
                      handleMultiPackageDimensionInputChange(event)
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Choose Measurement"
                      variant="standard"
                    />
                  )}
                />
              </div>
              <Grid
                container
                direction="row"
                alignItems="center"
                spacing={1}
                style={{ margin: "10px 0" }}
              >
                <Grid item xs={12} sm={12} md={6} lg={3}>
                  <TextField
                    label="Postal Code"
                    variant="standard"
                    name="postal_code"
                    value={values && values.postal_code && values.postal_code !== '' ? values.postal_code.toUpperCase() : ""}
                    inputProps={{ maxLength: 6 }}
                    onChange={(e) => {
                     const valueWithoutSpaces = e.target.value.replace(/\s/g, "").toUpperCase();
                      onInputChange({
                        target: {
                          name: e.target.name,
                          value: valueWithoutSpaces,
                        },
                      });
                    }}
                    onKeyDown={(e) => {
                      if (e.key === " ") {
                        e.preventDefault(); // block spacebar
                      }
                    }}
                    error={errors.postal_code}
                    helperText={errors.postal_code}
                    style={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={3}>
                  <TextField
                    label="City"
                    variant="standard"
                    name="city"
                    value={values.city}
                    inputProps={{ maxLength: 30 }}
                    onChange={onInputChange}
                    error={errors.city}
                    helperText={errors.city}
                    style={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={3}>
                  <FormControl
                    variant="standard"
                    className="help-text-error"
                    style={{ width: "100%" }}
                  >
                    <InputLabel id="demo-simple-select-standard-label">
                      Country
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-error"
                      name="country_code"
                      error={errors.country_code}
                      onChange={(event) => {
                        onSelectCountryChange(event.target.value);
                      }}
                      label="Country"
                    >
                      {filteredCountryData.map((key) => {
                        return (
                          <MenuItem value={key.code}>
                            {key.icon} {key.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                    <FormHelperText>{errors.country_code}</FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={3}>
                  <FormControl
                    variant="standard"
                    className="help-text-error"
                    style={{ width: "100%" }}
                  >
                    <InputLabel id="demo-simple-select-standard-label">
                      Province / State
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      onChange={onInputChange}
                      name="province_code"
                      error={errors.province_code}
                      label="Province / State"
                    >
                      {state &&
                        state.data.map((key) => {
                          return (
                            <MenuItem key={key.code} value={key.code}>
                              {key.name}
                            </MenuItem>
                          );
                        })}
                    </Select>
                    <FormHelperText>{errors.province_code}</FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                alignItems="center"
                spacing={1}
                style={{ margin: "10px 0" }}
              >
                <Grid item xs={12} sm={12} md={6} lg={3}>
                  <TextField
                    label="Address"
                    variant="standard"
                    name="address1"
                    value={values.address1}
                    inputProps={{ maxLength: 35 }}
                    onChange={onInputChange}
                    error={errors.address1}
                    helperText={errors.address1}
                    style={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={3}>
                  <TextField
                    label="Length"
                    variant="standard"
                    name="length"
                    type="number"
                    inputProps={{ min: 1 }}
                    value={values.length}
                    onChange={onInputChange}
                    error={errors.length}
                    helperText={errors.length}
                    style={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={3}>
                  <TextField
                    label="Width"
                    variant="standard"
                    name="width"
                    type="number"
                    inputProps={{ min: 1 }}
                    value={values.width}
                    onChange={onInputChange}
                    error={errors.width}
                    helperText={errors.width}
                    style={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={3}>
                  <TextField
                    label="Height"
                    variant="standard"
                    name="height"
                    type="number"
                    inputProps={{ min: 1 }}
                    value={values.height}
                    onChange={onInputChange}
                    error={errors.height}
                    helperText={errors.height}
                    style={{ width: "100%" }}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                alignItems="center"
                spacing={1}
                style={{ margin: "10px 0" }}
              >
                <Grid item xs={12} sm={12} md={6} lg={3}>
                  <FormControl
                    variant="standard"
                    className="help-text-error"
                    style={{ width: "100%" }}
                  >
                    <InputLabel id="demo-simple-select-standard-label">
                      {" "}
                      Dimension Unit{" "}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      name="dimension_unit"
                      onChange={onInputChange}
                      value={values.dimension_unit}
                      label="Dimension Unit"
                      id="filled-error-helper-text"
                    >
                      <MenuItem value="in">in</MenuItem>
                      <MenuItem value="cm">cm</MenuItem>
                    </Select>
                    <FormHelperText>{errors.dimension_unit}</FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={3}>
                  <TextField
                    label="Weight"
                    variant="standard"
                    name="weight"
                    inputProps={{ min: 1 }}
                    type="number"
                    value={values.weight}
                    onChange={onInputChange}
                    error={errors.weight}
                    helperText={errors.weight}
                    style={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={3}>
                  <FormControl
                    variant="standard"
                    className="help-text-error"
                    style={{ width: "100%" }}
                  >
                    <InputLabel id="demo-simple-select-standard-label">
                      {" "}
                      Weight Unit{" "}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      name="weight_unit"
                      onChange={onInputChange}
                      value={values.weight_unit}
                      label="Weight Unit"
                    >
                      <MenuItem value="kg">kg</MenuItem>
                      <MenuItem value="lb">lb</MenuItem>
                    </Select>
                    <FormHelperText>{errors.weight_unit}</FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <div style={{ textAlign: "center" }}>
                  <LoadingButton
                    variant="outlined"
                    onClick={handleSubmit}
                    style={{ margin: "0 15px" }}
                    loading={rates && rates.loading}
                  >
                    Get Rates
                  </LoadingButton>
                  {profile &&
                    profile.profile &&
                    profile.profile.hide_rate_drawer === true &&
                    rates &&
                    rates.loading === false &&
                    rates &&
                    rates.data &&
                    rates.data.length !== 0 &&
                    isRateShown && (
                      <Button
                        variant="outlined"
                        color="primary"
                        style={{ marginRight: "15px", cursor: "unset" }}
                      >
                        <AttachMoneyIcon
                          style={{
                            paddingRight: "10px",
                          }}
                        />
                        <span style={{ fontWeight: "600" }}>
                         {profile.profile.hide_rate === true ? "0.0" : formatRate()} 
                        </span>
                      </Button>
                    )}
                </div>
              </Grid>
            </Item>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={4} style={{ padding: "10px" }}>
          <Item
            style={{
              height: (onboarding &&
                onboarding.data &&
                onboarding.data.length !== 0) ? "445px" : "340px",
              overflowY: "auto"
            }}
          >
            <Grid container direction="row" spacing={1} sx={{ mb: 2 }}>
              <Grid item xs={12} md={12}>
                <h3 style={{ margin: "unset", paddingBottom: "5px" }}>
                  Account Notifications
                </h3>
                {onboarding && onboarding.loading === true && (
                  <LinearProgress />
                )}
              </Grid>
              <Grid item xs={12} md={12}>
                {onboarding &&
                  onboarding.data &&
                  onboarding.data.length !== 0 &&
                  onboarding.loading === false && (
                    <>
                      {onboarding && onboarding.data && (
                        <>
                          {Object.entries(onboarding.data).map(
                            ([key, value]) => (
                              <>
                                {value.title != "Carrier Credentials" &&
                                  value.title !=
                                  "Carrier Credentials Usage" && (
                                    <>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <div
                                          style={{
                                            padding: "0 20px",
                                            width: "80%",
                                          }}
                                        >
                                          <h4
                                            style={{
                                              paddingTop: "10px",
                                              margin: "unset",
                                            }}
                                          >
                                            {value.title}
                                          </h4>
                                          <p style={{ margin: "10px 0" }}>
                                            {value.message}
                                          </p>
                                        </div>
                                        {value.title === "Billing Address" && (
                                          <div
                                            style={{
                                              paddingBottom: "10px",
                                              width: "20%",
                                            }}
                                          >
                                            <Link
                                              to="/settings/address-billing"
                                              style={{ color: "#1976d2" }}
                                            >
                                              Configure
                                            </Link>
                                          </div>
                                        )}
                                        {(value.title === "Sender Address" ||
                                          value.title ===
                                          "Sender Address Default") && (
                                            <div
                                              style={{
                                                paddingBottom: "10px",
                                                width: "20%",
                                              }}
                                            >
                                              <Link
                                                to="/settings/address-sender"
                                                style={{ color: "#1976d2" }}
                                              >
                                                Configure
                                              </Link>
                                            </div>
                                          )}
                                        {(value.title === "Box Dimensions" ||
                                          value.title ===
                                          "Box Dimensions Default") && (
                                            <div
                                              style={{
                                                paddingBottom: "10px",
                                                width: "20%",
                                              }}
                                            >
                                              <Link
                                                to="/settings/box"
                                                style={{ color: "#1976d2" }}
                                              >
                                                Configure
                                              </Link>
                                            </div>
                                          )}
                                        {(value.title ===
                                          "Carrier Credentials" ||
                                          value.title ===
                                          "Carrier Credentials Usage") && (
                                            <div
                                              style={{
                                                paddingBottom: "10px",
                                                width: "20%",
                                              }}
                                            >
                                              <Link
                                                to="/integration/carriercredentials"
                                                style={{ color: "#1976d2" }}
                                              >
                                                Configure
                                              </Link>
                                            </div>
                                          )}
                                        {value.title ===
                                          "Account Activation" && (
                                            <div
                                              style={{
                                                paddingBottom: "10px",
                                                width: "20%",
                                              }}
                                            >
                                              <Link
                                                to="/settings/payment"
                                                style={{ color: "#1976d2" }}
                                              >
                                                Add
                                              </Link>
                                            </div>
                                          )}
                                      </div>
                                      <Divider />
                                    </>
                                  )}
                              </>
                            )
                          )}
                        </>
                      )}
                    </>
                  )}
              </Grid>

              {onboarding &&
                onboarding.data &&
                onboarding.data.length === 0 && (
                  <Grid item xs={12} md={12}>
                    <div
                      style={{
                        display: "flex",
                        minHeight: "200px",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <h4>No notifications</h4>
                    </div>
                  </Grid>
                )}
            </Grid>
          </Item>
        </Grid>
      </Grid>
      <RateDrawer
        visible={visible}
        onClose={onClose}
        formDataValues={formDataValues}
        reportName="DASHBOARD_FETCH_RATES"
      />
      <TrackingDrawer
        visible={trackingDrawerVisible}
        isMultiPiece={isMultiPiece}
        onClose={trackingDraweronClose}
      />
      {newOrderCreateDrawerVisible && (
        <NewOrderCreateDrawer
          visible={newOrderCreateDrawerVisible}
          reportName={"DASHBOARD"}
          newOrderFormData={newOrderFormData}
          setNewOrderFormData={setNewOrderFormData}
          onClose={newOrderCreateOnClose}
          setNewOrderCreateDrawerVisible={setNewOrderCreateDrawerVisible}
          isReturnOrder={isReturnOrder}
          setIsReturnOrder={setIsReturnOrder}
        />
      )}
      {bulkOrderCreateDrawerVisible && (
        <BulkOrderCreateDrawer
          visible={bulkOrderCreateDrawerVisible}
          onClose={bulkOrderCreateOnClose}
        />
      )}
    </>
  );
};

export default DashboardPage;
